var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4,
    y: -4,
    width: 56,
    height: 56
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_1056_21050_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 17.5,
    fill: "url(#paint0_linear_1056_21050)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 17.5,
    stroke: "url(#paint1_linear_1056_21050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 14C21.38 14 19.25 16.13 19.25 18.75C19.25 21.32 21.26 23.4 23.88 23.49C23.96 23.48 24.04 23.48 24.1 23.49C24.12 23.49 24.13 23.49 24.15 23.49C24.16 23.49 24.16 23.49 24.17 23.49C26.73 23.4 28.74 21.32 28.75 18.75C28.75 16.13 26.62 14 24 14Z",
    fill: "#B9FF66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0809 26.1499C26.2909 24.2899 21.7409 24.2899 18.9309 26.1499C17.6609 26.9999 16.9609 28.1499 16.9609 29.3799C16.9609 30.6099 17.6609 31.7499 18.9209 32.5899C20.3209 33.5299 22.1609 33.9999 24.0009 33.9999C25.8409 33.9999 27.6809 33.5299 29.0809 32.5899C30.3409 31.7399 31.0409 30.5999 31.0409 29.3599C31.0309 28.1299 30.3409 26.9899 29.0809 26.1499Z",
    fill: "#B9FF66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_1056_21050_clip_path",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 17.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1056_21050",
    x1: 48,
    y1: 0.00000346023,
    x2: -4.08204,
    y2: 43.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAF99C",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAF99C",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1056_21050",
    x1: 48,
    y1: 0.00000346023,
    x2: -4.08204,
    y2: 43.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9FF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1F1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.3b1ad0b32f6dc59f919b55f19cacbfdd.svg";
export { ForwardRef as ReactComponent };